export const currencySymbols = {
  USD: "$",
  CNY: "¥",
  EUR: "€",
  GBP: "£",
  JPY: "¥",
  AUD: "A$",
  CAD: "C$",
} as const;

export type CurrencyCode = keyof typeof currencySymbols;

export const supportedCurrencies: {
  code: CurrencyCode;
  symbol: (typeof currencySymbols)[CurrencyCode];
}[] = Object.entries(currencySymbols).map(([code, symbol]) => ({
  code: code as CurrencyCode,
  symbol,
}));

export const languageNames = {
  en: "English",
  zh: "中文",
  es: "Español",
  fr: "Français",
  de: "Deutsch",
  it: "Italiano",
  ja: "日本語",
} as const;

export type LanguageCode = keyof typeof languageNames;

export const supportedLanguages: {
  code: LanguageCode;
  name: (typeof languageNames)[LanguageCode];
}[] = Object.entries(languageNames).map(([code, name]) => ({
  code: code as LanguageCode,
  name,
}));
